var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard__card" },
    [
      _vm.loaders.dashboardData ? _c("CardLoading") : _vm._e(),
      _vm._v(" "),
      _vm.hasAudiologyKPIs
        ? _c(
            "div",
            {
              staticClass: "dashboard__card-content",
              class: { loadingBlur: _vm.loaders.dashboardData }
            },
            [
              _c("div", { staticClass: "dashboard__card-header" }, [
                _c("h2", { staticClass: "dashboard__card-title" }, [
                  _vm._v("Audiology KPIs")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "dashboard__card-title-addendum" }, [
                  _vm._v(_vm._s(_vm.dateRange))
                ]),
                _vm._v(" "),
                _vm._m(0)
              ]),
              _vm._v(" "),
              _vm.yearPrior.year
                ? _c(
                    "div",
                    {
                      staticClass:
                        "row dashboard__card-body dashboard__card-body--bordered"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "dashboard__grid dash-audiology-kpi__content-container"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-6 dashboard__card-body-col dash-audiology-kpi__content-col-container"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__year" },
                                [
                                  _vm.fiscalYear
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-audiology-kpi__date"
                                        },
                                        [_vm._v(_vm._s(_vm.yearPrior.year))]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-audiology-kpi__date"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.yearPrior.year) +
                                              " / " +
                                              _vm._s(_vm.yearCurrent.year)
                                          )
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("YTD")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("Net revenue")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currency(
                                        _vm.yearPrior.net_revenue,
                                        "$"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("Net profit")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currency(
                                        _vm.yearPrior.net_profit,
                                        "$"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("Net units")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [_vm._v(_vm._s(_vm.yearPrior.net_units))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("HAE appts")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [_vm._v(_vm._s(_vm.yearPrior.hae_appts))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("Patients purch")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.yearPrior.patient_purchases)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("Net ASP")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currency(_vm.yearPrior.net_asp, "$")
                                    )
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-6 dashboard__card-body-col dash-audiology-kpi__content-col-container"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__year" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "dash-audiology-kpi__date" },
                                    [_vm._v(_vm._s(_vm.yearCurrent.year))]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("YTD")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("Net revenue")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currency(
                                        _vm.yearCurrent.net_revenue,
                                        "$"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("Net profit")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currency(
                                        _vm.yearCurrent.net_profit,
                                        "$"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("Net units")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [_vm._v(_vm._s(_vm.yearCurrent.net_units))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("HAE appts")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [_vm._v(_vm._s(_vm.yearCurrent.hae_appts))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("Patients purch")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.yearCurrent.patient_purchases)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__category" },
                                [_vm._v("Net ASP")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dash-audiology-kpi__value" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currency(_vm.yearCurrent.net_asp, "$")
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _c("div", { staticClass: "row dashboard__card-body" }, [
                    _vm._m(1)
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "dashboard__card-footer" }, [
                _c(
                  "div",
                  { staticClass: "dashboard__card-link" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "dashboard__card-link-text",
                        attrs: { to: "/audiology-kpis" }
                      },
                      [_vm._v("View All")]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        : _c(
            "div",
            {
              staticClass: "dashboard__audio-kpis__teaser",
              class: { loadingBlur: _vm.loaders.dashboardData }
            },
            [
              _c("div", { staticClass: "dashboard__audio-kpis__teaser--bg" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dashboard__audio-kpis__teaser--content" },
                [
                  _vm._v(
                    "\n      Please speak with your Regional Manager about how tracking KPIs can work for your practice.\n    "
                  )
                ]
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "dashboard__card-title-icon dashboard__card-title-icon--audio-kpi"
      },
      [_c("i", { staticClass: "fa fa-chart-bar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-warning" }, [
      _c("div", { staticClass: "dashboard__no-data" }, [
        _vm._v("No KPI Data Available")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }